/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjcxIDIuMDAwMDRMMTEgMS4yOTAwNEw0LjI5MDA0IDguMDAwMDRMMTEgMTQuNzFMMTEuNzEgMTRMNS43MTAwNCA4LjAwMDA0TDExLjcxIDIuMDAwMDRaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==";